"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _seatsService = require("@insided/deprecated-control/services/seatsService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SeatLimitBanner = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SeatLimitBanner, _Component);

  var _super = _createSuper(SeatLimitBanner);

  function SeatLimitBanner() {
    var _this;

    (0, _classCallCheck2.default)(this, SeatLimitBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      limit: 0,
      current: 0
    });
    return _this;
  }

  (0, _createClass2.default)(SeatLimitBanner, [{
    key: "getSeatsSettings",
    value: function () {
      var _getSeatsSettings = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response, _response$data, limit, current;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _seatsService.seatsService.getData();

              case 3:
                response = _context.sent;
                _response$data = response.data, limit = _response$data.limit, current = _response$data.current;
                this.setBodyClassName({
                  limit: limit,
                  current: current
                });
                this.setState({
                  limit: limit,
                  current: current
                });
                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function getSeatsSettings() {
        return _getSeatsSettings.apply(this, arguments);
      }

      return getSeatsSettings;
    }()
  }, {
    key: "setBodyClassName",
    value: function setBodyClassName(_ref) {
      var limit = _ref.limit,
          current = _ref.current;
      var body = document.getElementsByTagName('body');

      if (body.length && !(!limit || !current || limit === 0 || current <= limit)) {
        body[0].classList.add('seat-limit-banner__show');
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _getInsidedData, mainRole;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getInsidedData = (0, _insidedDataStorage.getInsidedData)('user'), mainRole = _getInsidedData.mainRole;

                if ((0, _permissions.isCommunityManager)(mainRole)) {
                  _context2.next = 4;
                  break;
                }

                this.setBodyClassName(this.state);
                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return this.getSeatsSettings();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var state = this.state;

      if (!state.limit || !state.current || state.limit === 0 || state.current <= state.limit) {
        return (0, _preact.h)("div", {
          className: "seat-limit-banner seat-limit-banner__hidden"
        });
      }

      return (0, _preact.h)("div", {
        className: "seat-limit-banner"
      }, (0, _preact.h)("div", {
        className: "seat-limit-banner__icon"
      }, (0, _preact.h)(_assets.default, {
        icon: "upgrade",
        width: 20,
        height: 20
      })), (0, _preact.h)("span", null, "Your team has exceeded the seat limit (", state.current, " out of ", state.limit, " assigned). Please manage your seats in ", (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/team")
      }, "Team\xA0Overview"), ", or email", ' ', (0, _preact.h)("a", {
        href: "mailto:csm@gainsight.com"
      }, "csm@gainsight.com"), "."));
    }
  }]);
  return SeatLimitBanner;
}(_preact.Component);

exports.default = SeatLimitBanner;